import { doc, getDoc, getDocFromServer } from "firebase/firestore";
import { db } from "../firebase";
import { GetServiceOpts, EntityGet, EntityServerGet } from "../types";
import { Phonenumber } from "./types";
import { transformMetadata, processTimestampFields } from "../utils";

export type PhonenumberGetService<T> = (
  id: string,
  opts?: GetServiceOpts
) => Promise<T | null>;

const get: PhonenumberGetService<EntityGet<Phonenumber>> = async (
  id,
  opts = {}
) => {
  const docRef = doc(db, `/phonenumber/${id}`);
  const { disableCache } = opts;
  const getFn = disableCache ? getDocFromServer : getDoc;
  const docSnap = await getFn(docRef);
  if (docSnap.exists()) {
    return processTimestampFields(
      transformMetadata({
        ...docSnap.data(),
        id: docSnap.id,
      } as EntityServerGet<Phonenumber>)
    ) as EntityGet<Phonenumber>;
  }
  return null;
};

export default get;
